// Shared web SPA locale state. Translation values are plain text, never HTML.
export const LOCALES = {
  "en": {
    "cowboyMode.label": "Cowboy-Coding mode",
    "cowboyMode.disabled": "Disabled",
    "cowboyMode.related": "Related Tasks Only",
    "cowboyMode.project": "Whole Project",
    "cowboyMode.hint": "After completion, starts fresh sessions for dependent tasks. Whole Project also continues remaining sprint work and later sprints. Bypass only.",
    "cowboyMode.refused": "Cowboy mode was disabled because this task no longer runs in Bypass mode. Reopen it to refresh its permission mode.",
    "nav.workspace": "Workspace",
    "nav.dashboard": "Dashboard",
    "nav.project": "Project",
    "nav.admin": "Admin",
    "nav.board": "Board",
    "nav.epics": "Epics",
    "nav.backlog": "Backlog",
    "nav.planning": "Planning",
    "nav.insights": "Insights",
    "nav.serverAgent": "Server Agent",
    "nav.settings": "Settings",
    "nav.allTasks": "All Tasks",
    "sidebar.allProjects": "All Projects",
    "sidebar.scope": "All Projects or project",
    "sidebar.newProject": "+ New Project…",
    "sidebar.openTab": "Open in New Tab",
    "sidebar.openProjectTab": "Open {name} in new tab",
    "sidebar.toggle": "Toggle sidebar",
    "sidebar.expand": "Expand sidebar",
    "sidebar.collapse": "Collapse sidebar",
    "navbar.toggleMenu": "Toggle menu",
    "navbar.install": "Install app",
    "navbar.notifications": "Notifications",
    "navbar.profile": "Profile",
    "navbar.security": "Security",
    "navbar.logout": "Logout",
    "navbar.theme": "Light / dark",
    "navbar.toggleTheme": "Toggle light or dark mode",
    "twofa.region": "Two-factor authentication recommendation",
    "twofa.heading": "Protect your account with 2FA",
    "twofa.body": "Recommended for password sign-in. Google sign-in already stays separate and does not require this.",
    "twofa.enable": "Enable 2FA",
    "twofa.dismissLabel": "Dismiss 2FA recommendation",
    "common.dismiss": "Dismiss",
    "status.pending": "Pending",
    "status.in_progress": "In Progress",
    "status.on_fire": "On Fire",
    "status.completed": "Completed",
    "status.canceled": "Canceled",
    "nav.planning.sprints": "Sprints Planning",
    "nav.planning.batches": "Batches Planning",
    "nav.planning.bags": "Bags Planning",
    "nav.planning.jars": "Jars Planning",
    "nav.planning.groups": "Groups Planning",
    "nav.planning.steps": "Steps Planning",
    "nav.planning.sprint": "Sprint Planning",
    "taskField.title": "Title",
    "taskField.description": "Description",
    "taskField.type": "Type",
    "taskField.status": "Status",
    "taskField.category": "Category",
    "taskField.sprint": "Sprint",
    "taskField.assignee": "Assignee",
    "taskField.urgency": "Urgency",
    "taskField.storyPoints": "Story points",
    "taskField.storyPointsInvalid": "Story points must be a whole number of 0 or more.",
    "taskField.dueDate": "Due date",
    "taskField.tags": "Tags",
    "taskField.dependencies": "Depends on",
    "taskField.parent": "Parent",
    "taskField.objective": "Objective",
    "taskField.objectiveHint": "Completes on its own once every subtask is closed. Subtasks usually come from the Objective chat in the Task App.",
    "taskField.agent": "Agent",
    "taskField.agentSection": "Agent run",
    "taskField.agentHint": "Settings the Task App uses when it starts this task.",
    "taskField.model": "Model",
    "taskField.modelPlaceholder": "Agent default",
    "taskField.effort": "Effort",
    "taskField.designMode": "Design mode",
    "taskField.designModeHint": "Runs Claude Code's /design skill with this task as its brief.",
    "taskField.permissionMode": "Permission mode",
    "taskField.cowboyMode": "Cowboy-Coding mode",
    "taskField.newSprint": "+ New {group}",
    "taskField.backlog": "Backlog",
    "taskField.none": "None",
    "category.CODING": "Coding",
    "category.HUMAN": "Human",
    "agent.default": "Project default",
    "agent.claude": "Claude Code",
    "agent.codex": "Codex",
    "agent.pi": "Pi",
    "agent.human": "Human",
    "effort.inherit": "Agent default",
    "effort.low": "Low",
    "effort.medium": "Medium",
    "effort.high": "High",
    "effort.max": "Max",
    "deps.placeholder": "Search tasks by key or title…",
    "deps.notFound": "{key} is not in this project — it may have been deleted.",
    "deps.self": "A task cannot depend on itself.",
    "deps.cycle": "{key} already depends on this task ({path}), so this would create a loop.",
    "deps.ancestor": "{key} is a parent of this task. A parent completes only after its subtasks, so this task could never start.",
    "deps.invalid": "{key} cannot be a dependency of this task.",
    "deps.blockedEdit": "Not saved yet — remove the highlighted dependency to save the others.",
    "deps.blockedCreate": "Fix the highlighted dependencies to create this task.",
    "deps.checkFailed": "Couldn't check dependencies: {error}",
    "deps.saveFailed": "Dependencies weren't saved: {error}",
    "deps.floorCreate": "{key} is in {group} {priority}, so this task will be created in {group} {floor}.",
    "deps.floorEdit": "{key} is in {group} {priority}, but this task, which waits for it, is in {group} {current}.",
    "deps.floorMove": "Move to {group} {floor}",
    "deps.done": "done",
    "parent.placeholder": "Search for a parent task…",
    "createTask.title": "New Task",
    "createTask.submit": "Create Task",
    "createTask.submitting": "Creating…",
    "createTask.cancel": "Cancel",
    "createTask.created": "Task created",
    "createTask.failed": "Failed to create task",
    "createTask.loadFailed": "Failed to load task form",
    "createTask.titlePlaceholder": "What needs to be done?",
    "createTask.details": "Details",
    "createTask.planning": "Planning",
    "createTask.relations": "Links",
    "taskField.dueDateInvalid": "Enter a complete date, or clear the field.",
    "taskField.yes": "Yes",
    "taskField.no": "No",
    "deps.retry": "Try again"
  },
  "uk": {
    "cowboyMode.label": "Ковбойський режим",
    "cowboyMode.disabled": "Вимкнено",
    "cowboyMode.related": "Лише пов’язані завдання",
    "cowboyMode.project": "Увесь проєкт",
    "cowboyMode.hint": "Після завершення запускає нові сесії для залежних завдань. Увесь проєкт також продовжує роботу в поточному й наступних спринтах. Лише без підтверджень.",
    "cowboyMode.refused": "Ковбойський режим вимкнено, оскільки завдання більше не працює без підтверджень. Відкрийте його знову, щоб оновити режим дозволів.",
    "nav.workspace": "Робочий простір",
    "nav.dashboard": "Огляд",
    "nav.project": "Проєкт",
    "nav.admin": "Адміністрування",
    "nav.board": "Дошка",
    "nav.epics": "Епіки",
    "nav.backlog": "Беклог",
    "nav.planning": "Планування",
    "nav.insights": "Аналітика",
    "nav.serverAgent": "Серверний агент",
    "nav.settings": "Налаштування",
    "nav.allTasks": "Усі завдання",
    "sidebar.allProjects": "Усі проєкти",
    "sidebar.scope": "Усі проєкти або окремий проєкт",
    "sidebar.newProject": "+ Новий проєкт…",
    "sidebar.openTab": "Відкрити в новій вкладці",
    "sidebar.openProjectTab": "Відкрити {name} в новій вкладці",
    "sidebar.toggle": "Перемкнути бічну панель",
    "sidebar.expand": "Розгорнути бічну панель",
    "sidebar.collapse": "Згорнути бічну панель",
    "navbar.toggleMenu": "Перемкнути меню",
    "navbar.install": "Встановити застосунок",
    "navbar.notifications": "Сповіщення",
    "navbar.profile": "Профіль",
    "navbar.security": "Безпека",
    "navbar.logout": "Вийти",
    "navbar.theme": "Світла / темна",
    "navbar.toggleTheme": "Перемкнути світлий або темний режим",
    "twofa.region": "Рекомендація щодо двофакторної автентифікації",
    "twofa.heading": "Захистіть обліковий запис за допомогою 2FA",
    "twofa.body": "Рекомендовано для входу за паролем. Вхід через Google працює окремо й не потребує цього налаштування.",
    "twofa.enable": "Увімкнути 2FA",
    "twofa.dismissLabel": "Закрити рекомендацію щодо 2FA",
    "common.dismiss": "Закрити",
    "status.pending": "Очікує",
    "status.in_progress": "В роботі",
    "status.on_fire": "Термінове",
    "status.completed": "Виконано",
    "status.canceled": "Скасовано",
    "nav.planning.sprints": "Планування спринтів",
    "nav.planning.batches": "Планування партій",
    "nav.planning.bags": "Планування сумок",
    "nav.planning.jars": "Планування банок",
    "nav.planning.groups": "Планування груп",
    "nav.planning.steps": "Планування кроків",
    "nav.planning.sprint": "Планування спринтів",
    "taskField.title": "Назва",
    "taskField.description": "Опис",
    "taskField.type": "Тип",
    "taskField.status": "Статус",
    "taskField.category": "Категорія",
    "taskField.sprint": "Спринт",
    "taskField.assignee": "Виконавець",
    "taskField.urgency": "Терміновість",
    "taskField.storyPoints": "Story points",
    "taskField.storyPointsInvalid": "Story points мають бути цілим числом від 0.",
    "taskField.dueDate": "Термін",
    "taskField.tags": "Теги",
    "taskField.dependencies": "Залежить від",
    "taskField.parent": "Батьківське завдання",
    "taskField.objective": "Ціль",
    "taskField.objectiveHint": "Завершується сама, щойно закрито всі підзавдання. Підзавдання зазвичай створює чат цілі в Task App.",
    "taskField.agent": "Агент",
    "taskField.agentSection": "Запуск агента",
    "taskField.agentHint": "Налаштування, які Task App використовує під час запуску цього завдання.",
    "taskField.model": "Модель",
    "taskField.modelPlaceholder": "Типова для агента",
    "taskField.effort": "Рівень міркування",
    "taskField.designMode": "Режим дизайну",
    "taskField.designModeHint": "Запускає навичку /design у Claude Code із цим завданням як брифом.",
    "taskField.permissionMode": "Режим дозволів",
    "taskField.cowboyMode": "Ковбойський режим",
    "taskField.newSprint": "+ Новий: {group}",
    "taskField.backlog": "Беклог",
    "taskField.none": "Немає",
    "category.CODING": "Розробка",
    "category.HUMAN": "Людина",
    "agent.default": "Типовий для проєкту",
    "agent.claude": "Claude Code",
    "agent.codex": "Codex",
    "agent.pi": "Pi",
    "agent.human": "Людина",
    "effort.inherit": "Типовий для агента",
    "effort.low": "Низький",
    "effort.medium": "Середній",
    "effort.high": "Високий",
    "effort.max": "Максимальний",
    "deps.placeholder": "Шукайте завдання за ключем або назвою…",
    "deps.notFound": "{key} немає в цьому проєкті — можливо, його видалено.",
    "deps.self": "Завдання не може залежати саме від себе.",
    "deps.cycle": "{key} вже залежить від цього завдання ({path}), тож утворилося б коло.",
    "deps.ancestor": "{key} — батьківське завдання для цього. Батьківське завдання завершується лише після підзавдань, тож це завдання ніколи не почнеться.",
    "deps.invalid": "{key} не може бути залежністю цього завдання.",
    "deps.blockedEdit": "Ще не збережено — приберіть позначену залежність, щоб зберегти решту.",
    "deps.blockedCreate": "Виправте позначені залежності, щоб створити завдання.",
    "deps.checkFailed": "Не вдалося перевірити залежності: {error}",
    "deps.saveFailed": "Залежності не збережено: {error}",
    "deps.floorCreate": "{key} у: {group} {priority}, тож завдання буде створено в: {group} {floor}.",
    "deps.floorEdit": "{key} у: {group} {priority}, але це завдання, яке на нього чекає, у: {group} {current}.",
    "deps.floorMove": "Перемістити в: {group} {floor}",
    "deps.done": "виконано",
    "parent.placeholder": "Шукайте батьківське завдання…",
    "createTask.title": "Нове завдання",
    "createTask.submit": "Створити завдання",
    "createTask.submitting": "Створення…",
    "createTask.cancel": "Скасувати",
    "createTask.created": "Завдання створено",
    "createTask.failed": "Не вдалося створити завдання",
    "createTask.loadFailed": "Не вдалося завантажити форму завдання",
    "createTask.titlePlaceholder": "Що потрібно зробити?",
    "createTask.details": "Подробиці",
    "createTask.planning": "Планування",
    "createTask.relations": "Зв’язки",
    "taskField.dueDateInvalid": "Введіть повну дату або очистьте поле.",
    "taskField.yes": "Так",
    "taskField.no": "Ні",
    "deps.retry": "Спробувати ще раз"
  },
  "zh": {
    "cowboyMode.label": "牛仔编程模式",
    "cowboyMode.disabled": "已禁用",
    "cowboyMode.related": "仅关联任务",
    "cowboyMode.project": "整个项目",
    "cowboyMode.hint": "完成后为依赖任务启动新会话。整个项目还会继续当前及后续迭代中的任务。仅限免确认模式。",
    "cowboyMode.refused": "此任务不再使用免确认模式，因此牛仔模式已禁用。请重新打开任务以刷新权限模式。",
    "nav.workspace": "工作区",
    "nav.dashboard": "概览",
    "nav.project": "项目",
    "nav.admin": "管理",
    "nav.board": "看板",
    "nav.epics": "史诗",
    "nav.backlog": "待办列表",
    "nav.planning": "规划",
    "nav.insights": "分析",
    "nav.serverAgent": "服务器智能体",
    "nav.settings": "设置",
    "nav.allTasks": "所有任务",
    "sidebar.allProjects": "所有项目",
    "sidebar.scope": "所有项目或单个项目",
    "sidebar.newProject": "+ 新建项目…",
    "sidebar.openTab": "在新标签页中打开",
    "sidebar.openProjectTab": "在新标签页中打开 {name}",
    "sidebar.toggle": "切换侧边栏",
    "sidebar.expand": "展开侧边栏",
    "sidebar.collapse": "收起侧边栏",
    "navbar.toggleMenu": "切换菜单",
    "navbar.install": "安装应用",
    "navbar.notifications": "通知",
    "navbar.profile": "个人资料",
    "navbar.security": "安全",
    "navbar.logout": "退出登录",
    "navbar.theme": "浅色 / 深色",
    "navbar.toggleTheme": "切换浅色或深色模式",
    "twofa.region": "双重身份验证建议",
    "twofa.heading": "使用双重身份验证保护账户",
    "twofa.body": "建议为密码登录启用此功能。Google 登录采用独立流程，无需此设置。",
    "twofa.enable": "启用双重身份验证",
    "twofa.dismissLabel": "关闭双重身份验证建议",
    "common.dismiss": "关闭",
    "status.pending": "待处理",
    "status.in_progress": "进行中",
    "status.on_fire": "紧急",
    "status.completed": "已完成",
    "status.canceled": "已取消",
    "nav.planning.sprints": "迭代规划",
    "nav.planning.batches": "批次规划",
    "nav.planning.bags": "袋规划",
    "nav.planning.jars": "罐规划",
    "nav.planning.groups": "分组规划",
    "nav.planning.steps": "步骤规划",
    "nav.planning.sprint": "迭代规划",
    "taskField.title": "标题",
    "taskField.description": "描述",
    "taskField.type": "类型",
    "taskField.status": "状态",
    "taskField.category": "类别",
    "taskField.sprint": "迭代",
    "taskField.assignee": "负责人",
    "taskField.urgency": "紧急程度",
    "taskField.storyPoints": "故事点",
    "taskField.storyPointsInvalid": "故事点必须是大于或等于 0 的整数。",
    "taskField.dueDate": "截止日期",
    "taskField.tags": "标签",
    "taskField.dependencies": "依赖于",
    "taskField.parent": "父任务",
    "taskField.objective": "目标",
    "taskField.objectiveHint": "所有子任务关闭后自动完成。子任务通常来自 Task App 的目标对话。",
    "taskField.agent": "代理",
    "taskField.agentSection": "代理运行",
    "taskField.agentHint": "Task App 启动此任务时使用的设置。",
    "taskField.model": "模型",
    "taskField.modelPlaceholder": "代理默认",
    "taskField.effort": "推理强度",
    "taskField.designMode": "设计模式",
    "taskField.designModeHint": "以此任务作为简报运行 Claude Code 的 /design 技能。",
    "taskField.permissionMode": "权限模式",
    "taskField.cowboyMode": "牛仔编程模式",
    "taskField.newSprint": "+ 新建{group}",
    "taskField.backlog": "待办池",
    "taskField.none": "无",
    "category.CODING": "编码",
    "category.HUMAN": "人工",
    "agent.default": "项目默认",
    "agent.claude": "Claude Code",
    "agent.codex": "Codex",
    "agent.pi": "Pi",
    "agent.human": "人工",
    "effort.inherit": "代理默认",
    "effort.low": "低",
    "effort.medium": "中",
    "effort.high": "高",
    "effort.max": "最高",
    "deps.placeholder": "按编号或标题搜索任务…",
    "deps.notFound": "{key} 不在此项目中，可能已被删除。",
    "deps.self": "任务不能依赖于自身。",
    "deps.cycle": "{key} 已依赖此任务（{path}），这会形成循环。",
    "deps.ancestor": "{key} 是此任务的父任务。父任务只有在子任务完成后才会完成，因此此任务永远无法开始。",
    "deps.invalid": "{key} 不能作为此任务的依赖。",
    "deps.blockedEdit": "尚未保存——移除高亮的依赖即可保存其余依赖。",
    "deps.blockedCreate": "请先修正高亮的依赖，再创建此任务。",
    "deps.checkFailed": "无法检查依赖：{error}",
    "deps.saveFailed": "依赖未保存：{error}",
    "deps.floorCreate": "{key} 位于{group} {priority}，因此此任务将创建在{group} {floor}。",
    "deps.floorEdit": "{key} 位于{group} {priority}，但等待它的此任务位于{group} {current}。",
    "deps.floorMove": "移到{group} {floor}",
    "deps.done": "已完成",
    "parent.placeholder": "搜索父任务…",
    "createTask.title": "新建任务",
    "createTask.submit": "创建任务",
    "createTask.submitting": "正在创建…",
    "createTask.cancel": "取消",
    "createTask.created": "任务已创建",
    "createTask.failed": "创建任务失败",
    "createTask.loadFailed": "无法加载任务表单",
    "createTask.titlePlaceholder": "需要完成什么？",
    "createTask.details": "详情",
    "createTask.planning": "规划",
    "createTask.relations": "关联",
    "taskField.dueDateInvalid": "请输入完整日期，或清空此字段。",
    "taskField.yes": "是",
    "taskField.no": "否",
    "deps.retry": "重试"
  },
  "es": {
    "cowboyMode.label": "Modo de programación vaquera",
    "cowboyMode.disabled": "Desactivado",
    "cowboyMode.related": "Solo tareas relacionadas",
    "cowboyMode.project": "Todo el proyecto",
    "cowboyMode.hint": "Al completar, inicia sesiones nuevas para tareas dependientes. Todo el proyecto continúa también con el trabajo del sprint actual y los siguientes. Solo sin confirmación.",
    "cowboyMode.refused": "El modo vaquero se desactivó porque esta tarea ya no se ejecuta sin confirmación. Ábrela de nuevo para actualizar sus permisos.",
    "nav.workspace": "Espacio de trabajo",
    "nav.dashboard": "Panel de control",
    "nav.project": "Proyecto",
    "nav.admin": "Administración",
    "nav.board": "Tablero",
    "nav.epics": "Épicas",
    "nav.backlog": "Trabajo pendiente",
    "nav.planning": "Planificación",
    "nav.insights": "Análisis",
    "nav.serverAgent": "Agente de servidor",
    "nav.settings": "Configuración",
    "nav.allTasks": "Todas las tareas",
    "sidebar.allProjects": "Todos los proyectos",
    "sidebar.scope": "Todos los proyectos o un proyecto",
    "sidebar.newProject": "+ Nuevo proyecto…",
    "sidebar.openTab": "Abrir en una pestaña nueva",
    "sidebar.openProjectTab": "Abrir {name} en una pestaña nueva",
    "sidebar.toggle": "Alternar barra lateral",
    "sidebar.expand": "Expandir barra lateral",
    "sidebar.collapse": "Contraer barra lateral",
    "navbar.toggleMenu": "Alternar menú",
    "navbar.install": "Instalar aplicación",
    "navbar.notifications": "Notificaciones",
    "navbar.profile": "Perfil",
    "navbar.security": "Seguridad",
    "navbar.logout": "Cerrar sesión",
    "navbar.theme": "Claro / oscuro",
    "navbar.toggleTheme": "Alternar modo claro u oscuro",
    "twofa.region": "Recomendación de autenticación de dos factores",
    "twofa.heading": "Protege tu cuenta con la autenticación de dos factores",
    "twofa.body": "Se recomienda para el inicio de sesión con contraseña. El inicio de sesión con Google es independiente y no requiere esta configuración.",
    "twofa.enable": "Activar autenticación de dos factores",
    "twofa.dismissLabel": "Cerrar recomendación de autenticación de dos factores",
    "common.dismiss": "Cerrar",
    "status.pending": "Pendiente",
    "status.in_progress": "En curso",
    "status.on_fire": "Urgente",
    "status.completed": "Completado",
    "status.canceled": "Cancelado",
    "nav.planning.sprints": "Planificación de sprints",
    "nav.planning.batches": "Planificación de lotes",
    "nav.planning.bags": "Planificación de bolsas",
    "nav.planning.jars": "Planificación de frascos",
    "nav.planning.groups": "Planificación de grupos",
    "nav.planning.steps": "Planificación de pasos",
    "nav.planning.sprint": "Planificación de sprints",
    "taskField.title": "Título",
    "taskField.description": "Descripción",
    "taskField.type": "Tipo",
    "taskField.status": "Estado",
    "taskField.category": "Categoría",
    "taskField.sprint": "Sprint",
    "taskField.assignee": "Responsable",
    "taskField.urgency": "Urgencia",
    "taskField.storyPoints": "Puntos de historia",
    "taskField.storyPointsInvalid": "Los puntos de historia deben ser un número entero igual o mayor que 0.",
    "taskField.dueDate": "Fecha límite",
    "taskField.tags": "Etiquetas",
    "taskField.dependencies": "Depende de",
    "taskField.parent": "Tarea principal",
    "taskField.objective": "Objetivo",
    "taskField.objectiveHint": "Se completa sola cuando se cierran todas sus subtareas. Las subtareas suelen venir del chat de objetivos de Task App.",
    "taskField.agent": "Agente",
    "taskField.agentSection": "Ejecución del agente",
    "taskField.agentHint": "Ajustes que Task App usa al iniciar esta tarea.",
    "taskField.model": "Modelo",
    "taskField.modelPlaceholder": "Predeterminado del agente",
    "taskField.effort": "Esfuerzo",
    "taskField.designMode": "Modo de diseño",
    "taskField.designModeHint": "Ejecuta la habilidad /design de Claude Code con esta tarea como encargo.",
    "taskField.permissionMode": "Modo de permisos",
    "taskField.cowboyMode": "Modo de programación vaquera",
    "taskField.newSprint": "+ Nuevo: {group}",
    "taskField.backlog": "Backlog",
    "taskField.none": "Ninguno",
    "category.CODING": "Programación",
    "category.HUMAN": "Humana",
    "agent.default": "Predeterminado del proyecto",
    "agent.claude": "Claude Code",
    "agent.codex": "Codex",
    "agent.pi": "Pi",
    "agent.human": "Humano",
    "effort.inherit": "Predeterminado del agente",
    "effort.low": "Bajo",
    "effort.medium": "Medio",
    "effort.high": "Alto",
    "effort.max": "Máximo",
    "deps.placeholder": "Busca tareas por clave o título…",
    "deps.notFound": "{key} no está en este proyecto; puede que se haya eliminado.",
    "deps.self": "Una tarea no puede depender de sí misma.",
    "deps.cycle": "{key} ya depende de esta tarea ({path}), así que se crearía un ciclo.",
    "deps.ancestor": "{key} es una tarea principal de esta. Una tarea principal solo se completa después de sus subtareas, así que esta tarea nunca podría empezar.",
    "deps.invalid": "{key} no puede ser una dependencia de esta tarea.",
    "deps.blockedEdit": "Aún sin guardar: quita la dependencia resaltada para guardar las demás.",
    "deps.blockedCreate": "Corrige las dependencias resaltadas para crear esta tarea.",
    "deps.checkFailed": "No se pudieron comprobar las dependencias: {error}",
    "deps.saveFailed": "No se guardaron las dependencias: {error}",
    "deps.floorCreate": "{key} está en {group} {priority}, así que esta tarea se creará en {group} {floor}.",
    "deps.floorEdit": "{key} está en {group} {priority}, pero esta tarea, que lo espera, está en {group} {current}.",
    "deps.floorMove": "Mover a {group} {floor}",
    "deps.done": "hecha",
    "parent.placeholder": "Busca una tarea principal…",
    "createTask.title": "Nueva tarea",
    "createTask.submit": "Crear tarea",
    "createTask.submitting": "Creando…",
    "createTask.cancel": "Cancelar",
    "createTask.created": "Tarea creada",
    "createTask.failed": "No se pudo crear la tarea",
    "createTask.loadFailed": "No se pudo cargar el formulario de la tarea",
    "createTask.titlePlaceholder": "¿Qué hay que hacer?",
    "createTask.details": "Detalles",
    "createTask.planning": "Planificación",
    "createTask.relations": "Relaciones",
    "taskField.dueDateInvalid": "Escribe una fecha completa o deja el campo vacío.",
    "taskField.yes": "Sí",
    "taskField.no": "No",
    "deps.retry": "Reintentar"
  }
};

let locale = 'en';
const listeners = new Set();

export function setLocale(language) {
  const next = Object.hasOwn(LOCALES, language) ? language : 'en';
  if (next === locale) return;
  locale = next;
  for (const listener of listeners) listener(locale);
}

export function getLocale() { return locale; }

export function subscribeLocale(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function hasTranslation(key) { return Object.hasOwn(LOCALES.en, key); }

export function t(key, params = {}) {
  const table = LOCALES[locale];
  const value = (Object.hasOwn(table, key) ? table[key] : undefined)
    ?? (hasTranslation(key) ? LOCALES.en[key] : key);
  return String(value).replace(/\{(\w+)\}/g, (match, name) =>
    Object.hasOwn(params, name) ? String(params[name]) : match);
}

// Refresh text/accessible labels in place, preserving controls and event handlers.
export function translateElements(root) {
  if (!root) return;
  for (const attr of ['text', 'title', 'aria-label']) {
    for (const el of root.querySelectorAll(`[data-i18n-${attr}]`)) {
      const value = t(el.getAttribute(`data-i18n-${attr}`));
      if (attr === 'text') el.textContent = value;
      else el.setAttribute(attr, value);
    }
  }
}
